import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollService {
  // Controlla se la pagina ATTUALE è autorizzata a mostrare il tasto
  private readonly isAllowedPage = signal(false);

  // Controlla se l'utente ha scrollato abbastanza da vedere il tasto
  private readonly isVisible = signal(false);

  // Signal calcolato per il componente
  showScrollButton = signal(false);

  constructor() {
    // Ascoltiamo lo scroll globale
    window.addEventListener('scroll', () => {
      const scrollThreshold = 300;
      const scrolled = window.scrollY > scrollThreshold;
      this.isVisible.set(scrolled);
      this.updateFinalVisibility();
    });
  }

  // Metodo da chiamare nel ngOnInit delle pagine desiderate
  setVisibility(allowed: boolean) {
    this.isAllowedPage.set(allowed);
    this.updateFinalVisibility();
  }

  private updateFinalVisibility() {
    this.showScrollButton.set(this.isAllowedPage() && this.isVisible());
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}